import { logEvent } from '@/pages/api/v1/utils';

import { getAdvertisedDiscount } from './variant';

import type { ReferredVisitorPopupContent } from './types';

export type ReferredVisitorPopupEventType = 'impression' | 'cta' | 'dismiss';

// Keeps the "c" from the A/B/C test so ids and analytics stay continuous
const POPUP_VARIANT = 'C';

export const getReferredVisitorPopupId = (partnerKey: string) =>
  `referred-visitor-popup-c-${partnerKey}`;

export const logReferredVisitorPopupEvent = ({
  type,
  popupId,
  content,
  partnerKey,
  asPath,
  nextPath,
}: {
  type: ReferredVisitorPopupEventType;
  popupId: string;
  content: ReferredVisitorPopupContent;
  partnerKey: string;
  asPath: string;
  nextPath: string;
}) =>
  logEvent({
    event_type: 'click',
    asPath,
    metadata: {
      type,
      popup_id: popupId,
      next_path: nextPath,
      popup_variant: POPUP_VARIANT,
      partner_key: partnerKey,
      creator_name: content.creatorName,
      has_discount: getAdvertisedDiscount(content) !== null,
    },
  });
